/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, Fragment, useRef } from 'react';
import UploadFile from 'src/common/components/UploadFile';
import { bitacoraApi } from 'src/api/modules/bitacora';
import notice from 'src/common/components/Notice';
import { filesAPI } from 'src/api/modules/files';
import { useSelector } from 'react-redux';
import UpFileResumable from './upFileResumable';
import { saveAs } from 'file-saver';
import { getUniqueNameFile } from 'src/utils/GetUniqueName';
import { STATIC_NAME } from './generic-pass';
import { structureAPI } from 'src/api/modules/structure';

const fileResumable = new UpFileResumable();
const logBook = (description) => {
	bitacoraApi.post({ accion: description });
};

export const saveFile = () => {
	if (fileResumable != null) fileResumable.subirArchivo();
};

async function descargaEnBloques(rutas, userMinosNet, setDescargados, descargados, type) {
	const bloques = 15;
	const maxIntentos = 6;
	const itemsFiles64 = [];

	const descargarArchivo = async (item) => {
		const params = {
			siteUrl: process.env.REACT_APP_URL_MINOSNET,
			folderRelativeUrl: 'Documentos compartidos',
			filePath:
				process.env.REACT_APP_URL_MINOSNET +
				'/Documentos compartidos/' +
				item.ruta,
			file: item.nombre,
			app: '1',
			userName: userMinosNet,
			[STATIC_NAME['PASS']]: '',
		};

		return filesAPI.downloadMinos(params).then((response) => {
			if (!response || response.size === 0) {
				return Promise.reject(new Error('Archivo vacío o no encontrado'));
			}

			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(response);
				reader.onloadend = () => {
					const base64data = reader.result;
					if (!base64data) {
						reject(new Error('Error leyendo archivo'));
					} else {
						resolve({
							file64: base64data.split(',')[1],
							nombre:
								isNaN(Number(item.nombre.split('_')[0])) || type === 'H'
									? item.nombre
									: item.nombre.slice(item.nombre.indexOf('_') + 1),
						});
					}
				};
				reader.onerror = () => reject(new Error('Error leyendo archivo'));
			});
		});
	};

	const procesarIntento = async (archivos, intento = 1) => {
		if (!archivos.length || intento > maxIntentos) return [];

		const fallidos = [];

		for (let i = 0; i < archivos.length; i += bloques) {
			const bloque = archivos.slice(i, i + bloques);

			const results = await Promise.allSettled(
				bloque.map((item) => descargarArchivo(item))
			);
			results.forEach((result, index) => {
				const archivo = bloque[index];
				if (result.status === 'fulfilled') {
					itemsFiles64.push(result.value);
					setDescargados && setDescargados(itemsFiles64.length);
				} else {
					fallidos.push(archivo);
				}
			});
		}

		if (fallidos.length && intento < maxIntentos) {
			const siguientesFallidos = await procesarIntento(fallidos, intento + 1);
			return siguientesFallidos;
		} else {
			return fallidos;
		}
	};

	const fallidosFinales = await procesarIntento(rutas);

	return { itemsFiles64, fallidosFinales };
}

export const downloadZip = async (
	rutas,
	user,
	setOpen,
	name,
	isMigrado,
	setDescargados,
	setIsDownloading,
	descargados,
	setTotales,
	type
) => {
	let userMinosNet = localStorage.getItem('UMN');
	let itemsFiles64 = [];

	let arrayNum = rutas.length - 1;

	if (isMigrado) {
		rutas.forEach((item) => {
			filesAPI
				.DownloadFilesMigrated(item.idEntidad, item.versionArchivo)
				.then((response) => {
					if (response.size > 0) {
						var reader = new FileReader();
						reader.readAsDataURL(response);
						reader.onloadend = function () {
							let base64data = reader.result;

							itemsFiles64.push({
								file64: base64data.split(',')[1],
								nombre: item.nombre,
							});
						};

						let numItem = itemsFiles64.length;

						if (numItem === arrayNum) {
							setTimeout(() => {
								createZip(itemsFiles64, setOpen, name);
							}, 9000);
						}
					}
				})
				.catch(() => {
					notice('Ha ocurrido un problema con la solicitud', 'error');
				});
		});
	} else {
		const result = await descargaEnBloques(
			rutas,
			userMinosNet,
			setDescargados,
			descargados,
			type
		);

		if (result.fallidosFinales.length) {
			const contenido = result.fallidosFinales
				.map((item) => `${item.nombre} - ${item.ruta}`)
				.join('\n');

			const blob = new Blob([contenido], { type: 'text/plain' });
			const url = URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = url;
			link.download = 'archivos_fallidos.txt';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(url);
		}

		if (result.itemsFiles64.length > 0) {
			createZip(result.itemsFiles64, setOpen, name);
		}
		if (result.itemsFiles64.length === 0) {
			setOpen(false);
			notice('No se pudo descargar archivos o no hay archivos ha descargar');
		}
		setDescargados && setDescargados(0);
		setTotales && setTotales(0);
		setIsDownloading && setIsDownloading(false);
	}
};

const createZip = (filesForZip, setOpen, name) => {
	var zip = require('jszip')();
	filesForZip.map((f) => {
		return zip.file(f.nombre, f.file64, { base64: true });
	});

	zip.generateAsync({ type: 'blob' }).then(function (content) {
		saveAs(content, name + '.zip');
	});

	setOpen(false);
	notice('Se ha generado la carpeta electrónica con exito', 'success');
	logBook('Descarga de ' + name);
};

export const download = (
	rutaP,
	nombreFileP,
	userName,
	setOpen,
	typeDownload,
	nameDown,
	setFileBase64 = null,
	type = null
) => {
	if (setOpen) setOpen(true);
	let userMinosNet = localStorage.getItem('UMN');

	setTimeout(() => {
		//const fileResumable = new UpFileResumable();
		//const datosDesifrados = fileResumable._desifrarDatos();
		const siteUrl = process.env.REACT_APP_URL_MINOSNET;
		const baseParams = {
			siteUrl,
			app: '1',
			userName: userMinosNet,
			[STATIC_NAME['PASS']]: '',
		};

		filesAPI
			.downloadMinos(
				type !== 'folder'
					? {
							...baseParams,
							folderRelativeUrl: 'Documentos compartidos',
							filePath: `${siteUrl}/Documentos compartidos/${rutaP}`,
							file: nombreFileP,
					  }
					: {
							...baseParams,
							folderRelativeUrl: `/Documentos compartidos/${rutaP}`,
					  }
			)
			.then((response) => {
				if (response.size > 0) {
					if (setFileBase64 !== null) {
						const reader = new FileReader();
						reader.readAsDataURL(response);
						reader.onloadend = () => {
							const base64data = reader.result;
							setFileBase64(
								base64data.replace('data:', '').replace(/^.+,/, '')
							);
						};
						return true;
					}
					let blob = new Blob([response]);
					let da = document.createElement('a');
					da.href = URL.createObjectURL(blob);

					if (type === 'folder') da.setAttribute('download', `carpeta.zip`);
					else
						da.setAttribute(
							'download',
							nameDown !== undefined ? nameDown : nombreFileP
						);

					da.click();
					URL.revokeObjectURL(da.href);
					if (setOpen) setOpen(false);
					logBook('Descarga de archivo ' + nombreFileP + ' de ' + typeDownload);
				} else {
					notice('No se pudo descargar el archivo de Minos', 'info');
				}
			})
			.catch((err) => notice('No se pudo descargar el archivo de Minos', 'info'))
			.finally(() => {
				if (setOpen) setOpen(false);
			});
	}, 3000);
};

export const UploadFileMinos = ({
	onSetName,
	control,
	title,
	UploadWhenChanhge,
	onUploaded,
	tipo,
	entidad,
	ruta,
	idEntidad,
	nombre,
	setOpen,
	setFlag = undefined,
	acceptOnly = [],
	myFiles = [],
	adicional,
	firstFile = false,
	allFiles,
	uniques,
	typeDownload,
	disabled,
	validUniqueName = false,
	estructureModule = false,
}) => {
	let fileResumable = new UpFileResumable();
	const [loader, setLoader] = useState(false);
	const { user } = useSelector((state) => state.auth);
	const [nombreFile, setNombreFile] = useState(nombre);

	useEffect(() => {
		fileResumable.initResumable({
			usuarioConsulta: `${user.nombre} ${user.apellidoPaterno} ${user.apellidoMaterno}`,
			ruta: ruta,
			responseError: onError,
			onChange: onFileInputChange,
			responseSuccess: responseMinos,
			idBTN: getId(),
			acceptOnly: acceptOnly,
			estructureModule: estructureModule,
		});
	}, []);

	const myFilesRef = useRef(myFiles);
	useEffect(() => {
		myFilesRef.current = myFiles;
	}, [myFiles]);

	const OnClickDownload = () => {
		download(
			ruta,
			nombreFile,
			`${user.nombre} ${user.apellidoPaterno} ${user.apellidoMaterno}`,
			setLoader,
			typeDownload
		);
	};

	const onError = (message) => {
		setOpen(false);
		notice(message, 'error');
	};

	const responseMinos = (files) => {
		files.forEach((file) => {
			if (setOpen) setOpen(true);
			setNombreFile(file.fileName);
			if (onSetName) onSetName(file.fileName);
			const dataPost = {
				nombre: file.fileName,
				idEntidad,
				entidad,
				tipo,
				ruta,
				nombreUsuario: `${user.nombre} ${user.apellidoPaterno} ${user.apellidoMaterno}`,
			};
			filesAPI
				.post(dataPost)
				.then((x) => {
					notice('Archivo cargado exitosamente', 'success');
					if (onUploaded) onUploaded(dataPost, file);
					if (setFlag !== undefined) setFlag(true);
				})
				.catch((x) => {
					notice(
						'Archivo cargado a minos exitosamente, pero no se pudo crear registro en SAOC',
						'info'
					);
					if (setFlag !== undefined) setFlag(true);
				})
				.finally(() => {
					if (setOpen) {
						setOpen(false); //termina la subida de archivos
					}
					if (setFlag !== undefined) setFlag(false);
				});
		});
	};

	const onFileInputChange = useCallback(
		async (event) => {
			if (setOpen) setOpen(true); //inicia la subida de archivos
			if (!event.file) {
				return;
			}

			if (myFilesRef.current.length !== 0) {
				const isAlreadyUploaded = myFilesRef.current.some(
					(item) => item.nombreOriginal === event.file.name
				);
				if (isAlreadyUploaded) {
					notice(
						'Para subir un archivo con el mismo nombre se debe hacer desde el botón "Nueva version""',
						'info'
					);
					setOpen(false);
					return;
				}
			}

			if (firstFile === true) {
				let newName = '1_' + event.fileName;
				event.fileName = newName;
			}

			if (adicional === true) {
				//Si es un archivo adicional valida el nombre para saber cuantas versiones hay
				// y le asigna el numero siguiente de version
				if (uniques.includes(event.fileName) === true) {
					let mismoFile = allFiles.filter(
						(e) => e.nombreOriginal === event.fileName
					);

					let obtenermayor = mismoFile.sort((a, b) => {
						return b.numeroFile - a.numeroFile;
					});

					let SigNum = Number(obtenermayor[0].numeroFile) + 1;
					let newName = SigNum + '_' + event.fileName;
					event.fileName = newName;
				}
				if (allFiles.some((e) => e.nombreNumero === event.fileName)) {
					//si el nombre del archivo cargado ya exite entre todas las versiones
					//valida el numero de la ultima version para asignar el siguiente numero de version
					let mismoFile = allFiles.filter(
						(e) => e.nombreNumero === event.fileName
					);

					let obtenermayor = mismoFile.sort((a, b) => {
						return b.numeroFile - a.numeroFile;
					});

					let SigNum = Number(obtenermayor[0].numeroFile) + 1;
					let newName = SigNum + '_' + event.fileName;
					event.fileName = newName;
				}
			}

			if (validUniqueName) {
			}

			if (UploadWhenChanhge === undefined || UploadWhenChanhge === true) {
				fileResumable.subirArchivo();
			}
		},
		[UploadWhenChanhge, setOpen]
	);

	const getId = () => {
		return `BtnuploadMinos${idEntidad}${title.replaceAll(' ', '')}`;
	};

	return (
		<Fragment>
			{control !== undefined ? (
				control
			) : (
				<UploadFile
					download={OnClickDownload}
					typeDownload={typeDownload}
					name={nombreFile}
					id={getId()}
					title={title}
					disabled={disabled}
					loader={loader}
				></UploadFile>
			)}
		</Fragment>
	);
};
